module.exports = __webpack_public_path__ + "static/media/13ITC2.db566a9c.jpg";